@if (!bhr || (bhr && !bhr.enabled)) {
<p class="mat-body-1">
  {{ "ONSIP_I18N.AVAILABLE_247" | translate }}
</p>
} @if (bhr && bhr.enabled) {
<div class="bhr-days">
  @for (bhr of formattedBhr; track bhr) {
  <div>
    <p class="day-title">{{ bhr.day | titlecase }}:</p>
    @if (!bhr.disabled) {
    <p class="mat-body-1">
      {{ bhr.start | date : "shortTime" }} - {{ bhr.end | date : "shortTime" }}
      <br />
    </p>
    } @if (bhr.disabled) {
    <p class="closed">{{ "ONSIP_I18N.CLOSED" | translate }}</p>
    }
  </div>
  }
</div>
}
